import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';

interface IShowMoreButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick(): void;
}

export const ShowMoreButton: React.FC<IShowMoreButtonProps> = ({ disabled, loading, onClick }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      beforeIcon={<IconActionReload16 color="current_color" />}
      theme="fill_secondary"
      size="L"
      fullWidth
      data-testid="ShowMoreButton"
    >
      Показать еще
    </Button>
  );
};
